
export default function CTA() {
  return (
    <section id="contact" className="relative min-h-[80vh] md:min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://static.readdy.ai/image/5e8897340d9d3c287a609e9913af4db2/6eac5de49979863e9191c6b6a63a184c.jpeg"
        alt="배경"
        className="absolute inset-0 w-full h-full object-cover"
      />

      <div className="relative z-10 text-center px-4 sm:px-6">
        <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white mb-6 md:mb-8 tracking-wide leading-tight">
          지금 바로<br className="sm:hidden" /> 시작하세요
        </h2>

        <div className="space-y-2 md:space-y-3 mb-8 md:mb-12">
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white font-light">
            온니잡과 함께라면
          </p>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white font-light">
            당신의 퀸알바 생활이 달라집니다
          </p>
        </div>

        <a 
          href="https://www.onnyjob.kr" 
          target="_blank" 
          rel="noopener noreferrer"
          className="group relative inline-flex items-center bg-black rounded-full overflow-hidden hover:scale-105 transition-transform duration-300"
        >
          <div className="absolute left-0 w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-[#8B5CF6] rounded-full flex items-center justify-center">
            <span className="text-white text-xl md:text-2xl">→</span>
          </div>
          <span className="pl-16 sm:pl-18 md:pl-20 pr-6 md:pr-8 py-4 md:py-5 text-white font-bold text-sm sm:text-base md:text-lg tracking-wider whitespace-nowrap">
            START NOW
          </span>
          <span className="pr-4 md:pr-6 text-white text-lg md:text-xl">↗</span>
        </a>
      </div>
    </section>
  );
}
